import React from 'react';
import './OurClients.scss';
import OurClientsLogos from "./OurClientsLogos/OurClientsLogos";
import Map from "./Map/Map";
 
function OurClients() {

    return (
        <div className="OurClients modal-bg">
            <div className="content">
                <div className={'titleKey'}>our clients</div>
                <div className={'title'}>Who We Work With</div>
                <div className={'underTitleText'}>
                    <span>
                        Supporting technology companies, <br/>
                        operational organizations and complex digital environments.
                    </span>
                    {/*<span className={'text-gradient'}>E-Commerce & Finance, Wholesale & Retail, Education, Advertisement. </span>*/}
                    {/*<span>Among our clients are:</span>*/}
                </div>
            </div>
            <OurClientsLogos />
            <div className="content">
                <Map />
            </div>
            <div className="content">
                <div className={'cards'}>
                    <div className={'cards__item'}>
                        <div className={'cards__item__title'}>
                            <span>Technology Companies</span>
                        </div>
                        <div className={'cards__item__text'}>
                            <span>Building scalable products and platforms</span>
                        </div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'cards__item__title'}>
                            <span>Operational Organizations</span>
                        </div>
                        <div className={'cards__item__text'}>
                            <span>Supporting mission-critical software environments</span>
                        </div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'cards__item__title'}>
                            <span>Educational & Infrastructure</span>
                        </div>
                        <div className={'cards__item__text'}>
                            <span>Designing reliable digital systems for long-term use</span>
                        </div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'cards__item__title'}>
                            <span>AI-Driven Product Teams</span>
                        </div>
                        <div className={'cards__item__text'}>
                            <span>Integrating applied AI into production workflows</span>
                        </div>
                    </div>
                </div>
                <div id={'how-we-think'}/>
            </div>
        </div>
    );
}

export default OurClients;
